import unorm from 'unorm'

import { BASE_CHARS } from './constants'

export const capitalizeFirstLetter = (str: string = '') =>
  str.charAt(0).toUpperCase() + str.slice(1)

export const removeSpecialCharacters = (str: string = '') => str.replace(/[/ \-]/g, '')

export const replaceAllSpaceWithDash = (str: string = '') => str.replace(/\s/g, '-')
export const replaceAllDashWithSpace = (str: string = '') => str.replace(/-/g, ' ')
export const replaceAllDashwithUnderscore = (str: string = '') => str.replace(/-/g, '_')
export const replaceAllUnderscoreWithDash = (str: string = '') => str.replace(/_/g, '-')

export const replaceSpacesAndDashes = (str: string = '') =>
  replaceAllSpaceWithDash(replaceAllDashwithUnderscore(str))
export const replaceAllDashesAndUnderscores = (str: string = '') =>
  replaceAllUnderscoreWithDash(replaceAllDashWithSpace(str))

export const removeBracketsAndSlashes = (str: string = '') => str.replace(/[\(\)\/]/g, '')

export const replaceAccentedCharacters = (str: string = '') =>
  unorm
    .nfkd(str)
    .split('')
    .map((c) => BASE_CHARS.find((bc) => bc.localeCompare(c, 'en', { sensitivity: 'base' }) === 0))
    .join('')

export const normalizeString = (town: string = '') =>
  replaceAccentedCharacters(removeBracketsAndSlashes(replaceSpacesAndDashes(town))).toLowerCase()
